import React, {memo, useEffect, useState} from 'react';

import {Outlet} from 'react-router-dom';
import {onWarmingUpStatus} from 'src/services/warmingUpService';

import {WifiStatusContextProvider} from '@/contexts/WifiStatusContext';
import useShowMixingAutoProfile from '@/hooks/useShowMixingAutoProfile';

import LockConcentrator from '../autoProfile/LockConcentrator';
import RefillBufferPopup from '../autoProfile/reusable/RefillBufferPopup';
import ScheduleProfilePopup from '../autoProfile/reusable/ScheduleProfilePopup';
import RunAutoProfile from '../autoProfile/RunAutoProfile';
import StopAutoProfile from '../autoProfile/StopAutoProfile';
import PauseAutoProfileModal from '../autoProfileModal/PauseAutoProfileModal';
import LicenseService from '../licenseService/LicenseService';
import TopMenu from '../menu/topmenu/TopMenu';
import RecoveryOfLiquidModal from '../recoveryOfLiquid/RecoveryOfLiquidModal';
// import InitializationServices from '../statusService/InitializationServices';
// import DataCollectionPopup from '../service/DataCollectionPopup';
import DataCollectionPopup from '../service/DataCollectionPopup';
import UpdateSoftwareService from '../statusService/UpdateSoftwareService';
import RecalibrationSystem from '../updateSystem/RecalibrationSystem';

function MainContainer() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    async function fetchData() {
      const response = await onWarmingUpStatus();
      setShow(response);
    }
    fetchData();
  }, []);

  // NOTE: show mixing loading if the auto profile state is mixing state
  useShowMixingAutoProfile();

  return (
    <div className="main disableTextSelect hideOverflow wrapper">
      <TopMenu />
      {/* <InitializationServices /> */}
      <UpdateSoftwareService />
      <LicenseService />
      <RecoveryOfLiquidModal />
      <RunAutoProfile />
      <StopAutoProfile />
      <RecalibrationSystem />
      <WifiStatusContextProvider>{show && <Outlet />}</WifiStatusContextProvider>
      <PauseAutoProfileModal />
      <ScheduleProfilePopup />
      <RefillBufferPopup />
      <DataCollectionPopup />
      <LockConcentrator />
    </div>
  );
}

MainContainer.propTypes = {};

export default memo(MainContainer);
